<div class="container pb-5">
    <div class="row pt-2">
        <mat-card class="col-12 mb-2">
            <mat-card-title>Registro de Entregas <ng-container *ngIf="!canSearchConsolidated"> -
                    {{service.user.centroCosto._id + ' - ' + service.user.centroCosto.deDescripcion}} </ng-container>
            </mat-card-title>
            <mat-card-content>
                <div class="row pt-2 align-items-center">

                    <div class="col-12 col-md-9">
                        <div class="row">
                            <div class="col-12 mt-1">
                                <div class="row">
                                    <div class="col-md-6 col-6" *ngIf="parameters">
                                        <div class="row full-height align-items-center">
                                            <mat-form-field class="col-12">
                                                <mat-label>Tipo de Artículo: </mat-label>
                                                <mat-select placeholder="Seleccionar" [(value)]="typeProduct"
                                                    (selectionChange)="loadConfigData()">
                                                    <mat-option *ngFor="let type of parameters.typeProducts"
                                                        [value]="type.ID">
                                                        {{ type.DESCRIPTION | titlecase}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-6" *ngIf="canSelectResponsible && parameters && townOrIe">
                                        <div class="row full-height align-items-center">
                                            <mat-form-field class="col-12">
                                                <mat-label>Responsable: </mat-label>
                                                <mat-select placeholder="Seleccionar" [(value)]="responsible"
                                                    (selectionChange)="loadConfigData()">
                                                    <mat-option *ngFor="let responsible of parameters.responsible"
                                                        [value]="responsible.ID">
                                                        {{ responsible.NAME | titlecase}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12" *ngIf="canSearchConsolidated">
                                        <div class="row full-height align-items-center">
                                            <mat-form-field class="col-12" appearance="legacy">
                                                <mat-label>Filtro (Municipio - I.E.)</mat-label>
                                                <input matInput placeholder="Filtro (Municipio - I.E.)"
                                                    [(ngModel)]="townOrIe" autocomplete="off"
                                                    (selectionchange)="loadConfigData()">
                                                <mat-icon matPrefix class="mr-2 cursor-pointer no-select"
                                                    (click)="openCenterSearch()">travel_explore</mat-icon>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="row justify-content-around align-items-center">
                            <div class="col-10 pl-sm-4">
                                <h6 class="d-inline"> Fecha Inicial:</h6>
                                <ng-container *ngIf="selectedDates">
                                    {{ selectedDates.startDate | date: 'mediumDate':null:'es-co'}}
                                </ng-container> <br>
                                <h6 class="d-inline"> Fecha Final:</h6>
                                <ng-container *ngIf="selectedDates">
                                    {{ selectedDates.endDate | date: 'mediumDate':null:'es-co'}}
                                </ng-container>
                            </div>
                            <div class="col-2 d-flex align-items-center flex-column">
                                <button mat-mini-fab color="primary" matTooltip="Seleccionar fechas"
                                    (click)="selectDates()">
                                    <mat-icon>calendar_today</mat-icon>
                                </button>
                                <button mat-mini-fab color="primary" matTooltip="Reiniciar Filtros"
                                    (click)="resetFilters()">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="container">
    <mat-progress-bar class="col-12" *ngIf="!loadingAssets" mode="indeterminate"></mat-progress-bar>
    <app-table [context]="this" [dynamicRowClass]="checkRowColor" [columns]="columns" [items]="assets"
        (reload)="this.loadData()">
        <div class="footer col-12 pt-2" *ngIf="!canExport">
            <div class="row justify-content-end">
                <button mat-raised-button [disabled]="!loadingAssets" (click)="exportTo('xlsx')" class="mr-2"
                    color="primary" matTooltip="Exportar a excel">
                    <mat-icon>receipt_long</mat-icon> Exportar a excel
                </button>
            </div>
        </div>
    </app-table>

</div>